import { PayloadAction } from '@reduxjs/toolkit';
import { IInsuranceProduct, IInsuranceProductsState } from '../features/InsuranceProducts/types';

export const InsuranceProductsReducer = {
  setInsuranceProducts: (
    state: IInsuranceProductsState,
    action: PayloadAction<IInsuranceProduct[]>
  ) => {
    state.products = action.payload;
    state.isLoaded = true;
  },

  updateProductVisibility: (
    state: IInsuranceProductsState,
    action: PayloadAction<{ product: string; visibility: 'SHOW' | 'SHOW_DISABLED' | 'HIDE' }>
  ) => {
    const productIndex = state.products.findIndex(p => p.product === action.payload.product);
    if (productIndex !== -1) {
      state.products[productIndex].visibility = action.payload.visibility;
    }
  },

  resetInsuranceProducts: (state: IInsuranceProductsState) => {
    state.products = [];
    state.isLoaded = false;
  }
}; 